<template>
  <div>
    <detail></detail>
  </div>
</template>
<script>
import detail from '../detail'
export default {
  components: {
    detail
  }
}
</script>



// WEBPACK FOOTER //
// myStartDetail.vue?60486dcb